import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { haccpApi, erroreHaccp } from '../haccpApi';

const TIPI = ['audio/webm', 'audio/mp4', 'audio/ogg'];
const MAX_SECONDI = 60;

// Domanda a voce: tocca per parlare, tocca di nuovo per inviare (massimo 1 minuto). L'audio non si salva.
export const useVoce = (onTesto) => {
  const [stato, setStato] = useState('fermo');
  const rec = useRef(null);
  const fine = useRef(null);
  const ultimo = useRef(onTesto);
  ultimo.current = onTesto;
  const annullato = useRef(false);
  useEffect(() => () => { annullato.current = true; rec.current?.state === 'recording' && rec.current.stop(); }, []);
  const supportato = typeof window !== 'undefined' && !!navigator.mediaDevices?.getUserMedia && typeof window.MediaRecorder !== 'undefined';

  const trascrivi = async (blob, tipo) => {
    setStato('trascrivo');
    try {
      const fd = new FormData();
      fd.append('audio', new File([blob], `domanda.${tipo.includes('mp4') ? 'mp4' : tipo.includes('ogg') ? 'ogg' : 'webm'}`, { type: tipo }));
      const r = await haccpApi.post('/assistente/voce', fd);
      ultimo.current(r.testo);
    } catch (e) { toast.error(erroreHaccp(e, 'Non ho capito: riprova')); } finally { setStato('fermo'); }
  };

  const avvia = async () => {
    try {
      const flusso = await navigator.mediaDevices.getUserMedia({ audio: true });
      const tipo = TIPI.find((t) => window.MediaRecorder.isTypeSupported?.(t)) || '';
      const r = new window.MediaRecorder(flusso, tipo ? { mimeType: tipo } : undefined);
      const pezzi = [];
      r.ondataavailable = (e) => e.data.size && pezzi.push(e.data);
      r.onstop = () => {
        flusso.getTracks().forEach((t) => t.stop());
        clearTimeout(fine.current);
        if (annullato.current) { annullato.current = false; setStato('fermo'); return; }
        const t = (r.mimeType || tipo || 'audio/webm').split(';')[0];
        trascrivi(new Blob(pezzi, { type: t }), t);
      };
      r.start();
      rec.current = r;
      setStato('ascolto');
      fine.current = setTimeout(() => r.state === 'recording' && r.stop(), MAX_SECONDI * 1000);
    } catch { toast.error('Microfono non disponibile: consenti l\'accesso al microfono'); setStato('fermo'); }
  };
  const ferma = () => { if (rec.current?.state === 'recording') rec.current.stop(); };
  return { stato, supportato, avvia, ferma };
};
